import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export const ProductPinnedEmptyList: FC = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center h-100 px-5 border-bottom border-start border-end">
      <div className="icon icon-xl text-secondary">push_pin</div>
      <h4 className="text-center text-secondary">
        <FormattedMessage id="productSelector.tab.pinned.empty.title" />
      </h4>
      <p className="text-center text-secondary">
        <FormattedMessage id="productSelector.tab.pinned.empty.subtitle" />
      </p>
    </div>
  );
};
